<template>
  <div>
    <b-modal 
      title="預覽帳單" 
      size="lg"
      centered 
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <img :src="img" />
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'PreviewBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    img: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    // show: {
    //   handler(newValue, oldValue) {
    //     if (newValue) this.getHelp();
    //   },
    //   immediate: false
    // }
  },
  mounted() {
   
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/components/modal/PreviewBillModal.vue